var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { parse, stringify } from '@vanillaes/csv';
export function parseCsvFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', (event) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const fileData = (_a = event.target) === null || _a === void 0 ? void 0 : _a.result;
            if (typeof fileData === 'string') {
                try {
                    const csvData = parse(fileData);
                    if (csvData.length > 1) {
                        const header = csvData[0];
                        csvData.splice(0, 1);
                        for (let i = 0; i < csvData.length; i++) {
                            normalizeCsvRowToMatchHeaderLength(csvData[i], header);
                        }
                        resolve({ header: header, rows: csvData });
                    }
                    else if (csvData.length === 1) {
                        reject(new Error('Only CSV header found (first row), CSV file should contain more than one row'));
                    }
                    else {
                        reject(new Error('CSV file appears to be empty'));
                    }
                }
                catch (e) {
                    reject(e);
                }
            }
            else {
                reject(new Error('Failed to read CSV file'));
            }
        }));
        reader.readAsText(file);
    });
}
function normalizeCsvRowToMatchHeaderLength(row, header) {
    if (row.length !== header.length) {
        row.splice(header.length);
        for (let i = row.length; i < header.length; i++) {
            row.push('');
        }
    }
}
export function stringifyCsvFile(csvFile) {
    return stringify([csvFile.header, ...csvFile.rows]);
}
export function stringifyCsvFileToDataUrl(csvFile) {
    return 'data:application/octet-stream,' + encodeURIComponent(stringifyCsvFile(csvFile));
}
